import './lib/vue-i18n'
import { createApp } from 'vue'
import appCore from 'app-core'
import { i18nLoader, setupBasicLocale } from 'app-core'
import Locale from './lang/meta'
import { createRouter, createWebHistory } from 'vue-router'
import store from './store'
import routes from './router'
import App from './App'
import './index.less'
import init from './lib/init'
import Login from './lib/login'
import dataOflogin from './data/login'
import { youMongEvent } from './lib/pv-event'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import './common.css'
import './assets/iconfont/iconfont.css'
import './assets/iconfont/iconfont'

import 'element-plus/dist/index.css'
import './useModule'
import initMicroApps from './lib/initMicroApps'
if (navigator.userAgent.toLowerCase().includes('dingtalk') || navigator.userAgent.toLowerCase().includes('feishu') || navigator.userAgent.toLowerCase().includes('lark')) {
    window.open = (e) => {location.href = e}
}
(async function () {
  await init(true) // 初始化先通过接口获取免授权的路径状态
  const  [res,] = await Promise.all([
    Login(),
    youMongEvent() // 全局埋点
  ])
  // 1.处理默认登录逻辑
  if (res.errorMsg) {
    alert(res.errorMsg)
  }
  // 2.登录后刷新
  if (res.reloadUrl) {
    if (window.$ztDataAction) {
      window.$ztDataAction.push({
        action: 'aplus.record',
        arguments: ['Button_Click_Home', 'CLK']
      })
    }
    window.location.replace(res.reloadUrl)
  } else {
    // 如果已登录则回到常规流程
    await init()
  }

  // 处理第三方登录
  dataOflogin.thirdAfterLogin()

  const app = createApp(App)
  // localStorage.setItem('WEB_LOCALE_LANGUAGE', 'zh_CN')
  // initalUserLocale()
  
  app.use(appCore)
  await Promise.all([
    setupBasicLocale(Locale)
  ])
  const route = createRouter({
    history: createWebHistory('/'),
    routes: routes
  })

  // 后台进入手工录单时不允许访问其他页面(除手工录单和支付), 否则退出重登
  route.beforeEach( async (to, from, next) => {
    await i18nLoader(to, 'pc-gateway')
    // if (to.query.hideMenu) localStorage.setItem('hideMenu', !!to.query.hideMenu ? true : '')
    let isHideMenu = localStorage.getItem('hideMenu')
    if (isHideMenu) {
      // 隐藏菜单栏
      let paths = ['/flight/manualOrder', '/votapub/flight/manualOrder', '/hotel/orderCreateByHand', '/train/manualOrder', '/train/orderCreate', '/train/createChange', '/pay-channel.html', '/logoutJsonp.html', '/logout', '/login']
      const pgPath = ['/pg/train/manualOrder', '/pg/train/orderCreate', '/pg/train/createChange', '/pg/flight/manualOrder']
      pgPath.forEach(pItem => paths.push(pItem))
      const toPath = to.path.replace('/v', '')
      if (paths.includes(toPath)) {
        next()
      } else {
        dataOflogin.out()
      }
    } else {
      next()
    }
  })

  app.use(store)
    .use(route)
    .mount('#subapp-container')

  initMicroApps()

})()



// 代客下单多账户互串逻辑适配
const daikeIdCache = localStorage.getItem('daikeId')
if (daikeIdCache) {
  let temp = document.title
  document.addEventListener('visibilitychange', function() {
    var isHidden = document.hidden;
    if (isHidden) {
        temp = document.title
        document.title = `[代客] ${JSON.parse(localStorage.getItem('localUserInfo') || '{}').userName || ''} - `  + temp;
    } else {
        if (daikeIdCache !== localStorage.getItem('daikeId')){
          alert('当前用户已变更')
          window.location.reload()
        }
        document.title = temp;
    }
  });
}